// API base. In production (IIS + ARR) this is the relative path "/api" which
// IIS reverse-proxies to the backend. In local dev it falls back to the
// backend running on localhost:8080. Override via REACT_APP_API_URL / .env.
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
// export const FILE_URL = 'https://web2.linhquyphapan.vn';
export const FILE_URL = process.env.REACT_APP_FILE_URL || 'http://localhost:8080/api/file/file-thumb?thumb=';
export const LINK_YOUTUBE_IMAGE = 'https://img.youtube.com/vi/{videoId}/0.jpg';
